import type { HelperResult } from '@openclassrooms/sdk-web';
import { clientApi } from '../../configuration';
import getCRUDHooks from '../../utils/services/getCRUDHooks';

type PrivacySettingTypes =
  | 'accept student policy'
  | 'accept talent marketplace conditions'
  | 'accept terms of service'
  | 'acknowledge loosing right of withdrawal period'
  | 'profile visibility'
  | 'provide accurate information'
  | 'share data to improve user experience'
  | 'share user payment method information with service provider'
  | 'share user profile to employers'
  | 'upload my highest certification proof on OpenClassrooms platform before jury'
  | 'allow auto apply to job opportunities';

type PrivacySettingValues = 'true' | 'false' | 'Anyone' | 'Only me' | 'Only members';

interface PrivacySetting {
  type: PrivacySettingTypes;
  value: PrivacySettingValues;
}

interface PrivacySettings {
  privacySettings: PrivacySetting[];
}

const { useFind: usePrivacySettings, useUpdate: useUpdatePrivacySettings } =
  getCRUDHooks<PrivacySetting>({
    entityName: 'UserPrivacySettings',
    find: ({ userId }) => {
      if (userId) {
        return clientApi.getOCClient().helpers.user.users.getPrivacySettings(userId);
      }

      return clientApi.getOCClient().helpers.user.me.getPrivacySettings();
    },
    update: (
      { privacySettings }: PrivacySettings,
      { userId, context }: { userId?: number; context: string }
    ): HelperResult<PrivacySettings> => {
      if (userId) {
        return clientApi
          .getOCClient()
          .helpers.user.users.partialUpdatePrivacySettings(userId, privacySettings, { context });
      }

      return clientApi
        .getOCClient()
        .helpers.user.me.partialUpdatePrivacySettings(privacySettings, { context });
    },
  });

export { usePrivacySettings, useUpdatePrivacySettings };
